import { render, staticRenderFns } from "./MaintenanceNotifications.vue?vue&type=template&id=eb98b3d8"
import script from "./MaintenanceNotifications.vue?vue&type=script&lang=js"
export * from "./MaintenanceNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports